import React, { useContext, useState, useEffect } from 'react'
import { HomeEventSection, SectionWrap } from './styles'
// import HomeRightSides from './HomeRightSide'
// import HomeLeftSide from './HomeLeftSide'
import { ThemeContext } from 'theme/ThemeProvider'
import HomeLeftSide from './HomeLeftSide'
import { useTranslation } from 'react-i18next'

const HomeEvent = () => {
	const { isDarkMode, theme } = useContext(ThemeContext)
	const { t } = useTranslation()
	const [backgroundImage, setBackgroundImage] = useState<string>('')

	// 브랜드별 이미지를 동적으로 로드
	useEffect(() => {
		const getBrandConfig = () => {
			try {
				return (window as any).BRAND_CONFIG || {}
			} catch {
				return {}
			}
		}

		const brandConfig = getBrandConfig()
		const brandName = (window as any).BRAND_THEME?.brandName || 'sample'
		
		// 브랜드별 이미지 경로 설정 (public 폴더 기준)
		const lightImage = `/images/brand/${brandName}/mainbggrow.png`
		const darkImage = `/images/brand/${brandName}/mainbggrow_dark.png`
		
		// 다크모드 여부에 따라 이미지 선택
		const selectedImage = isDarkMode ? darkImage : lightImage
		
		// 이미지 존재 확인 후 설정
		const img = new Image()
		img.onload = () => {
			setBackgroundImage(selectedImage)
		}
		img.onerror = () => {
			// 브랜드별 다크 이미지가 없으면 라이트 이미지 시도
			if (isDarkMode && selectedImage.includes('_dark.png')) {
				const lightVersionImage = selectedImage.replace('_dark.png', '.png')
				const fallbackImg = new Image()
				fallbackImg.onload = () => setBackgroundImage(lightVersionImage)
				fallbackImg.onerror = () => {
					// 브랜드별 라이트 이미지도 없으면 기본 이미지 사용
					setBackgroundImage('/images/mainbggrow.png')
				}
				fallbackImg.src = lightVersionImage
			} else {
				// 라이트 이미지가 없으면 기본 이미지 사용
				setBackgroundImage('/images/mainbggrow.png')
			}
		}
		img.src = selectedImage
	}, [isDarkMode])

	console.log('현재 배경 이미지:', backgroundImage)

	return (
		<HomeEventSection
			isDarkMode={isDarkMode}
			style={{ flexDirection: 'column' }}>
			<SectionWrap
				style={{
					marginTop: 0,
					 background: `url(${backgroundImage}) center no-repeat`,
				}}>
				<HomeLeftSide />
			</SectionWrap>
		</HomeEventSection>
	)
}

export default HomeEvent
